export default __webpack_public_path__ + "static/media/grid-view-icon.1e5bd195.svg";